import React, { useState, useEffect } from 'react';
import { cantieri as cantieriApi } from '../../utils/api';

export default function NoteTab({ cantiereId }) {
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    cantieriApi.get(cantiereId)
      .then(res => setNote(res.data?.note || ''))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [cantiereId]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await cantieriApi.update(cantiereId, { note });
    } catch { /* global handler */ }
    finally { setSaving(false); }
  };

  if (loading) return <div style={{ padding: 20, color: 'var(--ds-muted)' }}>Caricamento note...</div>;

  return (
    <div>
      <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>📝 Note private</div>
      <textarea
        value={note}
        onChange={e => setNote(e.target.value)}
        placeholder="Appunti interni sul cantiere..."
        style={{
          width: '100%', minHeight: 200, padding: 14,
          borderRadius: 'var(--radius-base)', border: '1px solid var(--ds-border)',
          fontSize: 13, fontFamily: 'inherit', resize: 'vertical',
          background: 'var(--ds-bg)', color: 'var(--ds-text)',
        }}
      />
      <div style={{ marginTop: 12, display: 'flex', justifyContent: 'flex-end' }}>
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            padding: '10px 20px', borderRadius: 'var(--radius-base)', minHeight: 44,
            border: 'none', background: 'var(--brand)', color: '#fff',
            cursor: saving ? 'wait' : 'pointer', fontSize: 13,
            fontWeight: 500, opacity: saving ? 0.6 : 1,
          }}
        >
          {saving ? 'Salvataggio...' : 'Salva note'}
        </button>
      </div>
    </div>
  );
}
